<template>
    <b-container>
        <b-row>
            <b-col cols="12" lg="6">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha inicio"
                    v-model="theService.startDate"
                    :required="true"
                    :hasError="$v.theService.startDate.$error"
                    error-message="Debe especificar la fecha"
                    :max-date="moment().toDate()"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <label
                    >Hora de inicio
                    <span class="field-required-mark">*</span></label
                >
                <b-form-input
                    id="type"
                    type="time"
                    @change="$v.theService.startHour.$touch()"
                    v-model="theService.startHour"
                ></b-form-input>
                <span class="field-error" v-if="$v.theService.startHour.$error">
                    Debe especificar la hora</span
                >
            </b-col>
            <b-col cols="12" lg="6" v-if="updating">
                <app-date-time-picker
                    :withTime="false"
                    label="Fecha Fin"
                    v-model="theService.endDate"
                    :required="true"
                    :hasError="$v.theService.endDate.$error"
                    error-message="Debe especificar la fecha"
                    :max-date="moment().toDate()"
                />
            </b-col>
            <b-col cols="12" lg="6" v-if="updating">
                <label
                    >Hora de finalización
                    <span class="field-required-mark">*</span></label
                >
                <b-form-input
                    id="type"
                    type="time"
                    @change="$v.theService.endHour.$touch()"
                    v-model="theService.endHour"
                ></b-form-input>
                <span class="field-error" v-if="$v.theService.startHour.$error">
                    Debe especificar la hora</span
                >
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-text-input
                    label="Documento del protegido"
                    id="plateDocument"
                    :required="true"
                    :hasError="$v.theService.plateDocument.$error"
                    errorMessage="Debe escribir el documento"
                    @input="$v.theService.plateDocument.$touch()"
                    v-model="theService.plateDocument"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-text-input
                    label="Nombre del protegido"
                    id="personName"
                    :required="true"
                    :hasError="$v.theService.personName.$error"
                    errorMessage="Debe escribir el nombre del protegido"
                    @input="$v.theService.personName.$touch()"
                    v-model="theService.personName"
                />
            </b-col>
            <b-col cols="12" lg="6">
                <app-form-select-input
                    :options="cities"
                    v-model="theService.cityId"
                    label="Ciudad"
                    @change="$v.theService.cityId.$touch()"
                    :required="true"
                    :has-error="$v.theService.cityId.$error"
                    error-message="Debe seleccionar la ciudad"
                />
            </b-col>
        </b-row>
    </b-container>
</template>
<script>
import { required, numeric, requiredIf } from 'vuelidate/lib/validators'
import bodyguardRepository from '@repositories/bodyguard.repository'
import { mapGetters, mapMutations } from 'vuex'
import * as mutations from '@store/commitTypes'
export default {
    name: 'bodyguard_service_form_personal',
    props: {
        bodyguardPhoto: {
            type: String,
            required: true,
        },
        gunPhotos: {
            type: Array,
            required: true,
        },
        latitude: {
            type: String,
            default: '',
        },
        longitude: {
            type: String,
            default: '',
        },
        service: {
            type: Object,
            default: null,
        },
        onSave: {
            type: Function,
        },
    },
    data: () => ({
        theService: {
            startDate: '',
            startHour: '',
            endDate: '',
            endHour: '',
            plateDocument: '',
            personName: '',
            cityId: '',
        },
    }),
    watch: {
        service(val) {
            if (!val) return

            this.tryAutoFill()
        },
    },
    validations: {
        theService: {
            startDate: { required },
            startHour: { required },
            endDate: {
                required: requiredIf(function() {
                    return this.updating
                }),
            },
            endHour: {
                required: requiredIf(function() {
                    return this.updating
                }),
            },
            plateDocument: { required, numeric },
            personName: { required },
            cityId: { required },
        },
    },
    computed: {
        ...mapGetters(['cities']),
        updating() {
            return !!this.service
        },
    },
    methods: {
        ...mapMutations({
            setCurrentService: mutations.SET_SELECTED_BODYGUARD_SERVICE,
        }),
        async saveService() {
            if (!this.updating) {
                await this.startService()
            } else {
                await this.updateService()
            }
            typeof this.onSave === 'function' && this.onSave()
        },
        async startService() {
            this.$v.$touch()
            if (this.$v.$invalid)
                return toastr.error(
                    'Debe diligenciar todos los campos obligatorios'
                )

            const formData = new FormData()
            Object.keys(this.theService).forEach(key =>
                formData.append(key, this.theService[key])
            )
            formData.append('userId', this.user.id)
            formData.append('serviceType', 'personal')
            formData.append('bodyguardPhoto', this.bodyguardPhoto)
            this.gunPhotos.forEach(photo =>
                formData.append('gunPhotos[]', photo)
            )
            formData.append('latitude', this.latitude)
            formData.append('longitude', this.longitude)

            const br = { ...bodyguardRepository }

            try {
                const {
                    data: { status, msg, service },
                } = await br.saveBodyguardService(formData)

                if (status) {
                    this.setCurrentService(service)
                    toastr.success('Servicio iniciado correctamente')
                    this.$bus.$emit('bodyguard-service-form.close')
                    this.clearForm()
                    this.$router.push({ name: 'activeBodyguardServicePage' })
                } else {
                    toastr.error(msg)
                }
            } catch (err) {
                this.handleErrors(err)
            } finally {
            }
        },
        setAutoDateTime() {
            if (!!this.selectedBodyguardService) return
            this.theService.startDate = moment().format('YYYY-MM-DD')
            this.theService.startHour = moment().format('HH:mm')
        },
        initialize() {
            this.setAutoDateTime()
            this.load('cities')
            this.tryAutoFill()
            this.theService.cityId = this.user.city.id
        },
        clearForm() {
            Object.keys(this.theService).map(key => (this.theService[key] = ''))
        },
        tryAutoFill() {
            if (!this.updating) return

            this.theService.startDate = moment(this.service.start_date).format(
                'YYYY-MM-DD'
            )
            this.theService.startHour = moment(this.service.start_date).format(
                'HH:mm'
            )
            this.theService.plateDocument = this.service.plate_document
            this.theService.personName = this.service.driver_person_name
            this.theService.cityId = this.service.city_id

            if (this.updating) {
                this.theService.endDate = moment(this.service.end_date).format(
                    'YYYY-MM-DD'
                )
                this.theService.endHour = moment(this.service.end_date).format(
                    'HH:mm'
                )
            }
        },
        async updateService() {
            const br = { ...bodyguardRepository }

            try {
                const { data } = await br.updateBodyguardService(
                    this.theService,
                    this.service.id
                )

                if (data.status) {
                    toastr.success(data.msg)
                } else {
                    toastr.error(data.msg)
                }
            } catch (err) {
                this.handleErrors(err)
            }
        },
    },
    created() {
        this.$bus.$on('bodyguard-service-personal.save', this.saveService)
        this.$bus.$on(
            'appBodyguardServiceFormPersonal.clearForm',
            this.clearForm
        )
    },
    mounted() {
        this.initialize()
    },
}
</script>
